import React from 'react'
import FormComptoir from '../../../Components/FormComptoir'

const AjouterComptoir = () => {
  return <FormComptoir />
}

export default AjouterComptoir
